<template>
  <div>
    <div class="__upload_photo_icon d-flex mx-auto justify-content-center align-items-center" @click="(event) => (img.length ? event.preventDefault() : $refs.fileInput.click())">
      <div v-if="img" class="__image_box">
        <img :src="img" class="__image" />

        <i class="fas fa-times-circle __close_icon" @click.stop="$emit('deleteImage')"></i>
      </div>

      <div v-else>
        <i :class="['fas fa-cloud-upload-alt __icon', { 'fas fa-spinner fa-spin': uploadLoading }]"></i>

        <div class="__upload_text_size">{{ title }}</div>

        <div class="__upload_second_title">{{ secondTitle }}</div>
      </div>
    </div>

    <input style="display: none" type="file" accept="image/*" @change="onFileSelected" ref="fileInput" />

    <Toast title="سایز فایل شما خارج از حد مجاز است." error :showToast="showToast" />
  </div>
</template>

<script>
import Toast from '../common/Toast.vue'
export default {
  components: { Toast },
  props: {
    img: { type: String, default: '' },
    secondTitle: { type: String, default: '' },
    maxWidth: { type: Number, required: false },
    maxHeight: { type: Number, required: false },
    uploadLoading: { type: Boolean, default: false },
    title: { default: 'برای آپلود عکس خود کلیک کنید' },
  },
  data() {
    return {
      showToast: false,
    }
  },
  methods: {
    onFileSelected(event) {
      this.showToast = false

      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        const img = new Image()

        img.onload = () => {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          canvas.width = img.width
          canvas.height = img.height
          ctx.drawImage(img, 0, 0)
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
          const width = imageData.width
          const height = imageData.height
          const dataUrl = canvas.toDataURL()
          if (!Number(this.maxWidth) && !Number(this.maxHeight)) this.$emit('uploadImage', { width, height, dataUrl: e.target.result })
          else if (Number(width) === Number(this.maxWidth) && Number(height) === Number(this.maxHeight)) this.$emit('uploadImage', { width, height, dataUrl: e.target.result })
          else this.showToast = true
        }
        img.src = e.target.result
      }

      reader.readAsDataURL(file)
    },
  },
}
</script>

<style scoped lang="scss">
.__upload_photo_icon {
  width: 100%;
  height: 250px;
  border-radius: 8px;
  position: relative;
  border: 2px dashed #ced4da;
}
.__upload_text_size {
  color: #495057;
  font-size: 20px;
  margin-top: 10px;
  text-align: center;
}

.__upload_second_title {
  color: #495057;
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}
.__icon {
  display: block;
  color: #74788d;
  font-size: 45px;
  text-align: center;
}

.__image_box {
  display: flex;
  height: 250px;
  overflow: hidden;
  position: relative;
  align-items: center;
  justify-content: center;
}

.__close_icon {
  top: 0;
  left: 0;
  color: gray;
  font-size: 1rem;
  cursor: pointer;
  margin: 20px 10px;
  position: absolute;
}

.__image {
  height: 100%;
  margin: auto;
  display: block;
  max-height: 85%;
  max-width: 100%;
}
</style>
